import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { styledWithTheme } from "../../context";
import { ExpanderContent } from "../../expander";
import { View } from "../../layout";
import { BACKGROUND_SHADE_COLOR } from "../html/constants";
import { getPaddingForCard } from "../expandable";
import { jsx as ___EmotionJSX } from "@emotion/core";
var ExpandableContentWrapper = styledWithTheme('div')(function (_ref) {
  var theme = _ref.theme,
      hasBackgroundColor = _ref.hasBackgroundColor,
      spacing = _ref.spacing;

  var _getPaddingForCard = getPaddingForCard(theme, spacing),
      _getPaddingForCard2 = _slicedToArray(_getPaddingForCard, 2),
      paddingVertical = _getPaddingForCard2[0],
      paddingHorizontal = _getPaddingForCard2[1];

  return {
    padding: "".concat(paddingVertical, "px ").concat(paddingHorizontal, "px"),
    backgroundColor: hasBackgroundColor ? theme.selectors.color(BACKGROUND_SHADE_COLOR) : undefined
  };
});

var CardExpandableContent = function CardExpandableContent(_ref2) {
  var isExpanded = _ref2.isExpanded,
      spacing = _ref2.spacing,
      hasBackgroundColor = _ref2.hasBackgroundColor,
      getExpandableContent = _ref2.expandableContent,
      data = _ref2.data,
      index = _ref2.index;
  return ___EmotionJSX(View, {
    width: "100%"
  }, ___EmotionJSX(ExpanderContent, {
    isExpanded: isExpanded
  }, getExpandableContent({
    data: data,
    index: index
  }).map(function (expandableContent, contentIndex) {
    return ___EmotionJSX(ExpandableContentWrapper, {
      key: contentIndex,
      spacing: spacing,
      hasBackgroundColor: hasBackgroundColor
    }, expandableContent);
  })));
};

export default CardExpandableContent;